<template>
    <form @submit="onSubmit" id="GetNationalCodeForm" class="mt-2 d-block">
        <b-form-group :label="$t('param.nationalCode')">
            <b-form-input type="number"
                          id="nationalCode"
						  inputmode="numeric"
                          :data-label="$t('param.nationalCode')"
                          class="form-control"
                          autocomplete="off"
                          v-model="nationalCode"
                          data-validations='["required","nationalcode"]'></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('param.password')">
            <b-form-input type="password"
                          id="password"
                          :data-label="$t('param.password')"
                          class="form-control"
                          autocomplete="off"
                          v-model="password"
                          data-validations='["required","password"]'></b-form-input>
        </b-form-group>
        <label @click="changeType('forgetPassword')" class="d-block pointer red">کلمه عبور خود را فراموش کرده اید؟</label>
        <b-form-checkbox id="rememberMe"
                         v-model="rememberMe"
                         name="rememberMe">
            مرا به خاطر بسپار
        </b-form-checkbox>
        <p class="alert alert-warning flo mt-2 errors" v-if="warnings.length">
            <label></label>
            <ul>
                <li v-for="(warning,warningIndex) in warnings" :key="warningIndex">
                    {{ $t(warning.type,{label:warning.label}) }}
                </li>
            </ul>
        </p>
        <p class="alert alert-danger mt-2 errors" v-if="errors.length">
            <label></label>
            <ul>
                <li v-for="(error,errorIndex) in errors" :key="errorIndex">
                    {{ $t(error.type) }}
                </li>
            </ul>
        </p>
        <div class="col-12 mt-2 pr-0 pl-0 float-right">
            <button class="btn btn-block custom-btn mt-2" type="submit" v-bind:disabled="loading">
                <span v-if="!loading">{{ $t('view.auth.login') }}</span>
                <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            </button>
        </div>
        <div class="col-12 pr-0 pl-0 float-right">
            <button class="btn btn-block custom-outline-btn mt-2" type="button" @click="changeType('signup')">
                <span>{{ $t('view.auth.signup') }}</span>
            </button>
        </div>
    </form>
</template>
<script>
    import store from "@/store";
    import utility from '@/plugins/utility';
    const form = new utility.form('#GetNationalCodeForm');
    const db = new utility.db();

    export default {

        data()
        {
            return {
                loading: false,
                rememberMe: false,
                warnings: [],
                errors: [],
                cities: [],
                nationalCode: '',
                password: ''
            }
        },

        methods: {
            gotoClub()
            {
				this.request('/api/App/GetCustomerInfo', null, (response) =>
				{
					if (response)
					{
						store.customer = response.meta.Customer
						const redirectPath = this.$route.query.redirect || "/club/dashboard";
						this.$router.push(redirectPath);
					}
					else
					{
						this.errors = [{ type: 'errors.server' }];
					}

				}, 'get');
            },

            changeType(value)
            {
                this.$emit('changeType', value)
            },

            onSubmit(evt)
            {
                evt.preventDefault()
                this.warnings = form.errors();
                this.errors = [];

                if (this.warnings.length == 0)
                {
                    this.request('/api/CustomerAuth/Login', { NationalCode: this.nationalCode, PassWord: this.password }, (response) =>
                    {
                        if (response.success)
                        {
							if (this.password.length < 8)
							{
								db.insert('__fcp', 1)
							}

                            if (this.rememberMe)
                                db.insert('__c', response.meta)

                            this.loading = true;

                            axios({
                                method: 'post',
                                url: '/create-token',
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                data: 'username=' + this.nationalCode + '&password=' + this.password + '&grant_type=password'
                            })
                                .then(response =>
                                {
                                    this.loading = false;
                                    if (response.data !== undefined)
                                    {
                                        if (response.data.access_token !== undefined)
                                        {
                                            store.token = response.data
                                            if (this.rememberMe)
                                                db.insert('__t', response.data);

                                            axios.defaults.headers.common['Authorization'] =
                                                'Bearer ' + store.token.access_token;

                                            this.gotoClub()
                                            return;
                                        }
                                    }

                                    this.errors = [{ type: 'errors.server' }];
                                })
                                .catch(error =>
                                {
                                    this.loading = false;
                                    this.errors = [{ type: 'errors.server' }];
                                });

                            return;
                        }

                        this.warnings = [{ type: 'validation.login' }];
                    })
                }
            },

            request(url, data, succees, method)
            {
                this.loading = true;
                axios({
                    method: method || 'post',
                    url: url,
                    data: data
                })
                    .then(response =>
                    {
                        this.loading = false;
                        succees(response.data)
                    })
                    .catch(error =>
                    {
                        this.errors = [{ type: 'errors.server' }];
                        this.loading = false;
                    });
            }
        }
    }
</script>
